const CentralInformationPage = ({ setActiveStep, setLastStep }) => {
  return "";
}

export default CentralInformationPage